import * as tslib_1 from "tslib";
import './maps.less';
import loadGoogleMapsApi from 'load-google-maps-api';
import { m } from '../../hyperscript';
import { createContext } from '../context';
import { View } from '../view';
import { EventManager } from './eventmanager';
import { MapPool } from './mappool';
export var MapsContext = createContext();
var Maps = /** @class */ (function (_super) {
    tslib_1.__extends(Maps, _super);
    function Maps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Maps.prototype.onCreate = function () {
        var _this = this;
        var _a = this.attrs, children = _a.children, on = _a.on, apiKey = _a.apiKey, region = _a.region, language = _a.language, className = _a.class, _b = _a.initial, initial = _b === void 0 ? {} : _b, options = tslib_1.__rest(_a, ["children", "on", "apiKey", "region", "language", "class", "initial"]);
        loadGoogleMapsApi({ key: apiKey, region: region, language: language })
            .then(function (maps) {
            var map = Maps.pool.create(function (dom) { return new maps.Map(dom); });
            var _a = initial.zoom, zoom = _a === void 0 ? 7 : _a, _b = initial.center, center = _b === void 0 ? {
                lat: 51.0030477,
                lng: 4.5000955
            } : _b;
            map.setOptions(tslib_1.__assign({ zoom: zoom, center: center }, options));
            if (_this.dom)
                _this.dom.appendChild(map.getDiv());
            _this.onRemove = function () {
                Maps.pool.release(map);
            };
            _this.map = map;
        })
            .then(m.redraw)
            .catch(console.error);
    };
    Maps.prototype.render = function () {
        var _a = this.attrs, className = _a.class, on = _a.on, options = tslib_1.__rest(_a, ["class", "on"]);
        if (this.map) {
            if (options)
                this.map.setOptions(options);
        }
        return m('.maps', { className: className }, this.map &&
            m(MapsContext.Provider, { value: this.map }, m(EventManager, {
                on: on,
                object: this.map
            }, this.children)));
    };
    Maps.pool = new MapPool();
    return Maps;
}(View));
export { Maps };
